import React from 'react';
import LoadingIcon from '../../../../LoadingIcon';
import TpInstanceService from '../../../../../Services/TpInstanceService.js';
import MultiChoice from './MultiChoice';
import ErrorMessage from '../../../../ErrorMessage';

export default class ThirdPartySourceMultiChoice extends React.Component {
  static defaultProps = {
    label: '',
    onChange: () => alert('ThirdPartySourceMultiChoice Onchange'),
    selected: [],
    fieldName: '',
    forEvaluator: false,
    forTpJobSearch: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      itemList: [],
      selected: null,
    };
    this.multiSelectOnChange = this.multiSelectOnChange.bind(this);
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selected !== this.props.selected) {
      this.populateListData();
    }
  }

  populateListData() {
    const noEvaluatorSources = ['Prism'];
    const noTpJobSearchSources = ['Apollo'];

    TpInstanceService.GetThirdPartyInstanceList()
      .then((result) => {
        const optValues = [];
        const selected = [];
        result.forEach((source) => {
          if (this.props.forEvaluator && noEvaluatorSources.includes(source.thirdPartySourceName)) {
            return;
          }
          if (this.props.forTpJobSearch && noTpJobSearchSources.includes(source.thirdPartySourceName)) {
            return;
          }
          const newValue = {
            label: source.thirdPartySourceName,
            value: source.thirdPartySourceName,
          };
          optValues.push(newValue);
          selected.push(newValue);
        });
        this.setState({
          itemList: optValues,
          loading: false,
          selected: selected,
        });
      })
      .catch((error) => ErrorMessage.SetErrorMessage('TPSMC56', error));
  }

  multiSelectOnChange(selected) {
    this.setState({ selected });
    this.props.onChange(selected);
  }

  renderList() {
    return (
      <MultiChoice
        label=''
        p-multiselect-panel={true}
        className='rmsc'
        options={this.state.itemList}
        selected={this.props.selected}
        value={this.state.selected}
        onChange={this.multiSelectOnChange}
        labelledBy='Select'
      />
    );
  }

  render() {
    return (
      <div className='w-100 text-center hover rounded arial'>
        {this.state.loading ? (
          <LoadingIcon
            loading={true}
            className='h6'
          />
        ) : (
          this.renderList()
        )}
      </div>
    );
  }
}
